import { Box, IconButton, Menu, MenuItem, Typography, styled } from '@mui/material'
import React, { useEffect, useState } from 'react'
import MuiDrawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import { AccountCircle, ChevronLeft, ChevronRight, LocationOn, LogoutOutlined, Place, PlaceRounded, Settings } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import SidebarButton from './SidebarButton';
import { useAuth } from '../../components/providers/AuthProvider';
import logo_rounded_5050 from "../../assets/images/logo_rounded_5050.png"


const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  // justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  justifyContent: 'space-between',
  marginLeft: "10px",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const openedMixin = (theme, drawerWidth) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme, drawerWidth) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});


const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open, width }) => ({
    width: { width },
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme, width),
      '& .MuiDrawer-paper': openedMixin(theme, width),
    }),
    ...(!open && {
      ...closedMixin(theme, width),
      '& .MuiDrawer-paper': closedMixin(theme, width),
    }),
  }),
);


const Sidebar = ({
  navItems,
  activeTab,
  setActiveTab,
  widthContracted,
  widthExpanded,
}) => {
  const [width, setWidth] = useState(widthContracted);
  const [expanded, setExpanded] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  // const [openUserMenu, setOpenUserMenu] = useState(false);
  const openUserMenu = Boolean(menuAnchor);

  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleClickUserIcon = (event) => {
    setMenuAnchor(event.currentTarget);
  };
  const handleUserMenuClose = async () => {
    setMenuAnchor(null);
  };

  const handleClickLogout = async () => {
    await logout();
    setMenuAnchor(null);
    navigate("/login");
  }

  useEffect(() => {
    // console.log("Expanded:", expanded);
    if (expanded) {
      setWidth(widthExpanded);
    }
    else {
      setWidth(widthContracted);
    }
  }, [expanded]);

  return (
    <Box
      component="nav"
    >
      <Drawer
        key="main-drawer"
        variant="permanent"
        anchor="left"
        open={expanded}
        width={width}
      >
        {/* Top header with icon and close arrow button */}
        <Box
          sx={{
            minHeight: "100%",
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            backgroundColor: "#484848",
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >

            {/* Side bar header / Logo */}

            <DrawerHeader>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'flex-end',
                  alignItems: 'center',
                  justifyContent: expanded ? 'initial' : 'center',
                }}
              >
                {/* <Typography fontWeight="600" fontFamily="Major Mono Display" fontSize="30px" color="#ffb703">P</Typography> */}
                <img
                  src={logo_rounded_5050} // Replace with your image path
                  alt="Logo"
                  style={{ width: 26, height: "auto" }} // Adjust size as needed
                />
                {expanded ?
                  <Typography fontWeight="300" ml="15px" fontSize="18px" color="#E3E3E3">POSH Energy</Typography>
                  :
                  <></>
                }
              </Box>
            </DrawerHeader>

            <Divider />

            {/* Apps buttons */}

            <List disablePadding>
              {
                navItems.map(({ text, icon, route }) => 
                  <SidebarButton
                    key={text}
                    text={text}
                    expanded={expanded}
                    active={text === activeTab}
                    icon={icon}
                    onClick={() => {
                      setActiveTab(text);
                      navigate(route);
                    }}
                  />
                )
              }
            </List>

            <Divider sx={{ bgcolor: "#6F6F6F", height: 2, width: "60%", margin: "auto", borderRadius: 2 }} />

            {/* Button to expand sidebar */}
            <SidebarButton
              key={"btn-expand"}
              text={null}
              expanded={expanded}
              icon={expanded ? <ChevronLeft /> : <ChevronRight />}
              onClick={() => {
                setExpanded(expanded => !expanded);
                // setActiveTab(text);
                // navigate(route);
              }}
            />

          </Box>

          {/* Bottom part: User */}
          <Box
            sx={{
              mt: "20px",
              mb: "20px",
            }}
          >

            <SidebarButton
              key={"btn-settings"}
              text={"Settings"}
              expanded={expanded}
              icon={<Settings />}
            />

            <SidebarButton
              key={"btn-user"}
              text={"User"}
              expanded={expanded}
              icon={<AccountCircle />}
              onClick={handleClickUserIcon}
            />


            <Menu
              id="user-icon-menu"
              sx={{
                width: "500px",
              }}
              MenuListProps={{
                'aria-labelledby': 'user-icon-button',
              }}
              anchorEl={menuAnchor}
              open={openUserMenu}
              onClose={handleUserMenuClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
              <MenuItem onClick={handleClickLogout} disableRipple>
                <LogoutOutlined />
                Log out
              </MenuItem>
            </Menu>

          </Box>

        </Box>

      </Drawer>
    </Box>

  )
}

export default Sidebar